import React from "react";
import { Link } from "react-router-dom";
import "./style.less";


const HomeIconList = (props) => {

  return (
    <div>
      <div className="block-header">
        <h3>{props.title}</h3>
      </div>

      <div className="icon-wrapper">
        <div className="icon-list">
          {
            props.icons.map((element, index) => {
              return (
                <div className="icon-item" key={index}>
                  <Link to={element.link}>
                    <img src={element.img} />
                    <span>{element.name}</span>
                  </Link>
                </div>
              )
            })
          }
        </div>
      </div>
    </div>
  )
}

export default HomeIconList;